// extracted by mini-css-extract-plugin
export default {"wrapper":"euZwJ7EQDCNi93SeXNAY","smallButton":"jPiiu2rGeWrieTz9PraQ"};